import React, { useState, useContext } from 'react';
import { Form, Field } from 'react-final-form';
import { InputText } from 'primereact/inputtext';
import { Button } from "primereact/button";
import { CommonButton } from "components/Buttons/Buttons";
import { Password } from 'primereact/password';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { classNames } from 'primereact/utils';
import { ToastCustomContainer } from '../../components/ToastNotifiyer';
import 'react-toastify/dist/ReactToastify.css';
import dekko_isho_icon from'./dekko-isho-icon.png';
import './FormDemo.css';
// import { useNavigate } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import { GetUsers, SignUp } from 'services/user/user.service';
import AuthContext from  "../../context/AuthContext";

export const Login = () => {

    const { loginUser, loading, loginError } = useContext(AuthContext);
    
    const [showMessage, setShowMessage] = useState(false);

    // const dispatch = useDispatch();
    // const navigate = useNavigate();

    // const { usersList, usersLoading, usersError } = useSelector((state) => state.users);
    // const { loginData, loginDataLoading, loginDataError } = useSelector((state) => state.login);

    // useEffect(() => {
    //     dispatch(GetUsers());
    // }, []);

    const validate = (data) => {
        let errors = {};

        if (!data.email) {
            errors.email = 'Email is required.';
        }
        else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.email)) {
            errors.email = 'Invalid email address. E.g. alim@dekkoisho.com';
        }

        if (!data.password) {
            errors.password = 'Password is required.';
        }
        return errors;
    };

    const onSubmit = (values, form) => {

        window.localStorage.clear();
        form.restart();

        loginUser(values);

        if(loginError){
            setShowMessage(true);
            form.restart();
        }

    };

    const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
    const getFormErrorMessage = (meta) => {
        return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
    };

    const dialogFooter = <div className="flex justify-content-center"><Button label="OK" className="p-button-text" autoFocus onClick={() => setShowMessage(false) } /></div>;
    const passwordHeader = <h6>Type your password</h6>;
    const passwordFooter = (
        <React.Fragment>
            <Divider />
            <p className="mt-2">Password pattern</p>
            <ul className="pl-2 ml-2 mt-0" style={{ lineHeight: '1.5' }}>
                <li>At least one lowercase</li>
                <li>At least one uppercase</li>
                <li>At least one numeric</li>
                <li>Minimum 8 characters</li>
            </ul>
        </React.Fragment>
    );

    return (
        <div className="form">
            <Dialog visible={showMessage} onHide={() => setShowMessage(false)} position="top" footer={dialogFooter} showHeader={false} breakpoints={{ '960px': '80vw' }} style={{ width: '30vw' }}>
                <div className="flex align-items-center flex-column pt-6 px-3">
                    <i className="pi pi-lock" style={{ fontSize: '5rem', color: 'red' }}></i>
                    <h5>You account is inactive!</h5>
                    <p style={{ lineHeight: 1.5, textIndent: '1rem' }}>
                        Please contact with admin for activation.
                    </p>
                    <a href="mailto:alim@dekkoisho.com" target="_top">alim@dekkoisho.com</a>
                </div>
            </Dialog>

            <div className="flex justify-content-center">
                <div className="card">
                    <div className="text-center">
                        <img src={dekko_isho_icon} alt="Dekko Isho Group"  height="40%" width="40%" />
                    </div>
                    <h2 className="text-center">Astha (আস্থা)</h2>
                    <Form onSubmit={onSubmit} initialValues={{ email: '', password: ''}} validate={validate} render={({ handleSubmit }) => (
                        <form onSubmit={handleSubmit} className="p-fluid">
                            <Field name="email" render={({ input, meta }) => (
                                <div className="field">
                                    <span className="p-float-label p-input-icon-right">
                                        <i className="pi pi-envelope" />
                                        <InputText id="email" autoComplete='true' {...input} className={classNames({ 'p-invalid': isFormFieldValid(meta) })} />
                                        <label htmlFor="email" className={classNames({ 'p-error': isFormFieldValid(meta) })}>Email*</label>
                                    </span>
                                    {getFormErrorMessage(meta)}
                                </div>
                            )} />
                            <Field name="password" render={({ input, meta }) => (
                                <div className="field">
                                    <span className="p-float-label">
                                        <Password id="password" autoComplete='true' {...input} toggleMask className={classNames({ 'p-invalid': isFormFieldValid(meta) })} header={passwordHeader} footer={passwordFooter} />
                                        <label htmlFor="password" className={classNames({ 'p-error': isFormFieldValid(meta) })}>Password*</label>
                                    </span>
                                    {getFormErrorMessage(meta)}
                                </div>
                            )} />
                            {/* <Button type="submit" label="Login 🔐" className="mt-2" />                      */}
                            <CommonButton loading={loading} className="mr-2 mb-2" title="Login" type="submit" label="Login 🔐" color="p-button-raised p-button-success"></CommonButton>
                        </form>
                    )} />
                </div>
            </div>
            <ToastCustomContainer />
        </div>
    );
}

// follow this link: https://www.primefaces.org/primereact/reactfinalform/